/**
 * Data access for the game entity (``GET /api/catalog/games/``). Read-only.
 */
import { useApiQuery, type QueryState } from "@shared/api";

import type { Game } from "./model";

export const GAMES_PATH = "/catalog/games/";

/** Fetch the active games in display order. */
export function useGames(): QueryState<readonly Game[]> {
  return useApiQuery<readonly Game[]>(GAMES_PATH);
}
